import React from 'react';
import { Platform } from 'utils/platform';

import { usePlayer } from './context';

const Player: React.FC<PlayerProps> = (props) => {
  const player = usePlayer(props);

  if (!player.Component) {
    return null;
  }

  return (
    <player.Component
      ref={player.ref}
      enablePip={props.enablePip}
      {...(!Platform.isAndroidTV && {
        enableInternalAndroidAutoRotate: props.enableInternalAndroidAutoRotate,
      })}
    />
  );
};

export default React.memo(Player);
